import { render } from "./PrimaryFormButtonIcon.vue?vue&type=template&id=acf92f56&scoped=true"
import script from "./PrimaryFormButtonIcon.vue?vue&type=script&lang=js"
export * from "./PrimaryFormButtonIcon.vue?vue&type=script&lang=js"

import "./PrimaryFormButtonIcon.vue?vue&type=style&index=0&id=acf92f56&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-acf92f56"

export default script